module.exports = __webpack_public_path__ + "static/pinkunicorn4-7788cc73f9c199fcfa7566e863351538.jpeg";